import React, { PropsWithChildren } from 'react'

import { CustomSizeType, SizeKeysMD, SizeKeysXL, SizeTypes } from '@ui/Types/SizeType'

import { useModalEffect, useModalHandlers } from './ModalDesktop'

import styles from './ModalMobile.module.scss'

export interface ModalProps extends PropsWithChildren {
  size?: SizeType
  onClose(): void
}

type SizeType = CustomSizeType<SizeTypes, SizeKeysMD | SizeKeysXL>

export const ModalMobile: React.FC<ModalProps> = (props) => {
  const { children } = props

  useModalEffect(props)
  const { handleContentClick, handleBackgroundMouseDown } = useModalHandlers(props)

  return (
    <div id='modal' className={styles.modalContainer}>
      <div
        className={styles.modalOverlay}
        onClick={handleBackgroundMouseDown}
        onMouseDown={handleBackgroundMouseDown}
      />
      <div className={styles.modal}>
        <div className={styles.modalCard} onClick={handleContentClick}>
          <div className={styles.modalWrapper}>{children}</div>
        </div>
      </div>
    </div>
  )
}
